const QUADS = [
  { hg: true, hs: true, title: "Star", alt: "Strategic Growth Asset", sub: "High Growth · High Share", head: "bg-emerald-50 border-emerald-200 text-emerald-700", note: "Invest to sustain leadership" },
  { hg: true, hs: false, title: "Question Mark", alt: "Speculative Asset", sub: "High Growth · Low Share", head: "bg-amber-50 border-amber-200 text-amber-700", note: "Selective investment — fund or exit" },
  { hg: false, hs: true, title: "Cash Cow", alt: "Core Operational Anchor", sub: "Low Growth · High Share", head: "bg-blue-50 border-blue-200 text-blue-700", note: "Harvest to fund growth" },
  { hg: false, hs: false, title: "Dog", alt: "Legacy Asset (Manage for Risk / Decommission)", sub: "Low Growth · Low Share", head: "bg-slate-100 border-slate-200 text-slate-600", note: "Manage for risk — decommission or divest" },
];

export default function AssetLifecycleBlueprint({ doc }) {
  const p = doc.payload || {};
  const gt = Number(p.growthThreshold ?? 10);
  const st = Number(p.shareThreshold ?? 50);
  const assets = (p.assets || []).filter((a) => a.name?.trim());
  const place = (q) => assets.filter((a) => (Number(a.growth) >= gt) === q.hg && (Number(a.share) >= st) === q.hs);

  return (
    <div className="space-y-3" data-testid="lifecycle-blueprint">
      <p className="text-xs text-slate-400 font-mono">Thresholds — growth ≥ {gt}%, relative share ≥ {st}%</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {QUADS.map((q) => {
          const items = place(q);
          return (
            <div key={q.title} data-testid={`lifecycle-quad-${q.title.toLowerCase().replace(/\s/g, "-")}`} title={`${q.title} / ${q.alt} — ${q.note}`} className="bg-white border border-slate-200 rounded-sm overflow-hidden">
              <div className={`px-4 py-3 border-b ${q.head}`}>
                <p className="font-mono text-sm font-bold uppercase tracking-wide">{q.title} <span className="opacity-70">/ {q.alt}</span></p>
                <p className="text-xs opacity-80">{q.sub} — {q.note}</p>
              </div>
              <div className="p-4 min-h-[120px]">
                {items.length === 0 ? <p className="text-sm text-slate-300">— None —</p> : (
                  <ul className="space-y-2">
                    {items.map((a) => (
                      <li key={a.id} className="flex items-start gap-2 text-sm text-slate-800">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" />
                        <span><span className="font-medium">{a.name}</span><span className="text-slate-400 text-xs"> · {a.growth || 0}% growth · {a.share || 0}% share{a.margin ? ` · ${a.margin}` : ""}</span></span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
